import { ContentSetData, ContentSetActions, ContentStatus } from "../../types/content.types";
import { ContentSetMenu } from "./contentsetmenu";
import { ContentSetTitle, checkContentTitle} from './contentsettitle';
import { ContentSetItem } from "./contentsetitem";

export const MAX_NUM_ITEMS:number=24;
const MAX_ITEMS_TXT:string="Maximun of 24 images";
const MIN_ITEMS_TXT:string="Minimum of 5 images";
const MIN_NUM_ITEMS:number=5;
const SIGNIN_MSG:string="Sign in to save this content.";

interface PropsType{
	showAll:boolean;
	isLoggedIn:boolean;
	userContentList:string[];
	contentStatus:ContentStatus;
	contentSetData:ContentSetData;
	contentSetMenuClick:(contentSetAction:ContentSetActions) => void;
	removeItemClick:(delItem: string) => void;
	updateContentSetTitle:(newTitle: string) => void;
	contentSetItemTextChange:(itemIndex: number, itemText: string) => void;
	isContentSetNew:boolean;
	showHelper:boolean;
}

export const ContentSet=function(props:PropsType){
	if(props.isContentSetNew===false&&props.contentSetData.title==='')return null;
	if(props.isContentSetNew===true&&props.contentSetData.imsList.length===0)return null;

	let items=[];
	if(props.showAll){
		for(let i=0;i<props.contentSetData.imsList.length;i++){
			items.push(<ContentSetItem
				itemIndex={i}
				isFirst={i===0}
				showHelper={props.showHelper}
				contentSetItemTextChange={props.contentSetItemTextChange}
				imSrc={props.contentSetData.imsList[i]}
				txt={props.contentSetData.txtsList[i]}
				removeItemClick={props.removeItemClick}
				key={props.contentSetData.imsList[i]}/>)
		}
	}

	
	let titleError=checkContentTitle(props.isContentSetNew, props.contentSetData.title, props.userContentList);
	let duplicatesMsg=getDuplicatesMessage(props.contentSetData.txtsList);
	let statusMsg=getStatusMessage(props.contentStatus);
	let numItemsMsg=getNumItemsMessage(props.contentSetData.imsList.length, props.showAll);

	let showTitleAndMenu=props.showAll&&props.isLoggedIn;
	let showSignInText=showTitleAndMenu===false&&props.isContentSetNew===true;


	return(
		<div>
			<hr />
			<ContentSetTitle
				showTitle={showTitleAndMenu}
				titleError={titleError}
				myTitle={props.contentSetData.title}
				isContentSetNew={props.isContentSetNew}
				updateContentSetTitle={props.updateContentSetTitle}
				/>
			<ContentSetMenu
				showMenu={showTitleAndMenu}
				isLoggedIn={props.isLoggedIn}
				isContentSetNew={props.isContentSetNew}
				titleError={titleError}
				numItems={props.contentSetData.imsList.length}
				contentSetMenuClick={props.contentSetMenuClick}
				/>
			{showSignInText && <h3>Your content</h3>}
			{statusMsg!=='' && <p className="teachers-statusmessage">{statusMsg}</p>}
			{numItemsMsg!=='' && <p className="teachers-statusmessage">{numItemsMsg}</p>}
			{duplicatesMsg!=='' && <p className="teachers-statusmessage">{duplicatesMsg}</p>}
			<div className="teachers-contentset-items">
				{items}
			</div>
			{showSignInText && <hr />}
			{showSignInText && <p className="teachers-statusmessage">{SIGNIN_MSG}</p>}
		</div>
	);
}

const getStatusMessage=function(contentStatus:ContentStatus){
	if(contentStatus===ContentStatus.GetSet)return "Loading ...";
	if(contentStatus===ContentStatus.SaveSet)return "Saving ...";
	if(contentStatus===ContentStatus.DeleteSet)return "Deleting ...";
	if(contentStatus===ContentStatus.GetSetError){
		return "Error - Failed to load set - Try again.";
	}
	if(contentStatus===ContentStatus.SaveSetError){
		return "Error - Failed to save set - Try again.";
	}
	if(contentStatus===ContentStatus.DeleteSetError){
		return "Error - Failed to delete set - Try again.";
	}
	return '';
};

const getNumItemsMessage=function(listLength:number, showAll:boolean){
	if(showAll){
		if(listLength>0&&listLength<MIN_NUM_ITEMS)return MIN_ITEMS_TXT;
		if(listLength>=MAX_NUM_ITEMS)return MAX_ITEMS_TXT;
	}
	return '';
};

const getDuplicatesMessage=function(txtList:string[]){
	const seen=new Map<string, string>();
	for(const text of txtList){
		if(text==='')continue;
		const key=text.toLowerCase();
		if(seen.has(key)){
			return `Duplicate text: '${seen.get(key)}'. Some games may not work.`;
		}
		seen.set(key, text);
	}
	return '';
}